import React from "react";
import { Button } from "react-bootstrap";

// css
import styles from "./Table.module.scss";
import { useNavigate } from "react-router-dom";

// image

const TableLayout = ({ column, data, url, filter, handleSort, noDataMessage, handleRowClick }) => {
  const navigate = useNavigate();

  const handleSortClick = (item) => {

    let sort = {};
    if (filter?.sort?.column == item?.accessor) {

      if (filter?.sort?.direction == "asc") sort = { column: item?.accessor, direction: "desc" };
      else sort = { column: "id", direction: "desc" };

    } else sort = { column: item?.accessor, direction: "asc" }

    typeof handleSort === "function" && handleSort(sort);
  };

  return (
    <>
      <div
        className={`${styles.tableResponsive} tableResponsive table-responsive mb-3`}
      >
        <table className={`${styles.table} table`}>
          <thead>
            <tr className="">
              {column &&
                column.length > 0 &&
                column.map((item, key) => (
                  <>
                    <th className={`text-dark fw-bold border-0 d ${item?.lastIndexSticky && "last-cloumn-sticky"}`} style={{ position: item?.lastIndexSticky ? 'sticky' : 'static', right: 0 }}>
                      {item?.headComponent ? (
                          item.headComponent(data, key)
                      ):(
                        <div className="d-flex">
                          {item.head}
                          {
                            item?.sorter && <div className="px-2 cursor-pointer d-flex flex-column justify-content-center" onClick={() => handleSortClick(item)}>
                              {filter?.sort?.column == item?.accessor && filter?.sort?.direction == "asc" ? <ArrowUpFilled /> : <ArrowUpOutline />}
                              {filter?.sort?.column == item?.accessor && filter?.sort?.direction == "desc" ? <ArrowDownFilled /> : <ArrowDownOutline />}
                            </div>
                          }
                        </div>
                      )}
                    </th>
                  </>
                ))}
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.length > 0 ?
              data.map((data, columnkey) => {
                return (
                  <tr
                    className={`${url && "cursor-pointer"}`}
                    onClick={() => {
                      url && navigate(`${url}/${data.id}`);
                      (handleRowClick && typeof handleRowClick == "function") && handleRowClick(data);
                    }}
                  >
                    {column &&
                      column.length > 0 &&
                      column.map((item, key) => {
                        if (item.component) {
                          return (
                            <td className="forteen" style={{ position: item?.lastIndexSticky ? 'sticky' : 'static', right: 0, borderLeft: item?.lastIndexSticky && "2px solid #dddddd80" }} >
                              {item.component(data, columnkey, data)}
                            </td>
                          );
                        }

                        return <td className="forteen">{data[item?.accessor] || "--"}</td>;
                      })}
                  </tr>
                );
              }) : (
                <tr>
                  <td colSpan={column?.length || 1} className="text-center forteen">{noDataMessage || "Data not found"}</td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TableLayout;

const ArrowUpFilled = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-up-fill"
      viewBox="0 0 16 16"
    >
      <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
    </svg>
  )
};

const ArrowDownFilled = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-down-fill"
      viewBox="0 0 16 16"
    >
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  )
}

const ArrowDownOutline = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-down"
      viewBox="0 0 16 16"
    >
      <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659" />
    </svg>
  )
}

const ArrowUpOutline = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-up"
      viewBox="0 0 16 16"
    >
      <path d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659" />
    </svg>
  )
}